<template>
  <div class="search-object-list-loading">
    <div class="search-list-header-placeholder">
      <div class="left" />
      <div class="right" />
    </div>
    <div class="search-object-placeholder" />
    <div class="search-object-placeholder" />
    <div class="search-object-placeholder" />
    <div class="search-object-placeholder" />
    <div class="search-object-placeholder" />
  </div>
</template>

<script>
/*

@@author        j0Shi
@@date          2019.11.14
@@desc          ObjectSearchList placeholder that shows when object page loads
@@usedby        Search -> SearchObjectList

*/
export default {

};
</script>

<style lang="scss" scoped>
$color1: #e1e1e1;

.search-list-header-placeholder {
  height: 25px;
  width: 100%;
  display: flex;
  margin-bottom: 15px;
  justify-content: space-between;

  .right,
  .left {
    width: 35%;
    background-color: $color1;
    border-radius: 10px;
  }
}

.search-object-placeholder {
  height: 250px;
  width: 100%;
  border-radius: 10px;
  background-color: $color1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;

  @media #{$media_sm_max} {
    height: 500px;
  }
}
</style>
